import React from 'react';
import Form from '../common/form';

import './Application.css';

function Application() {
  return (
    <main className="application">
      <Form />
    </main>
  );
}

export default Application;
